<form [formGroup]="specROWFormGroup">
    <div formGroupName="specificatieROW">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col col-1">
                    <p>Resultaat uit overige werkzaamheden</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            align="right"
                            class="custom-input-150"
                            formControlName="berekendResultaatUitOverigeWerkzaamheden"
                            id="berekendResultaatUitOverigeWerkzaamheden"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>

            <div class="row">
                <div class="col col-1">
                    <p>Inkomsten terbeschikkingstellingsregeling</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            align="right"
                            class="custom-input-150"
                            formControlName="berekendResultaatTBS"
                            id="berekendResultaatTBS"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>
